var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavigationArrowLeftThick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "navigation-arrow-left-thick") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Icon awesome-arrow-circle-left"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 3940",
    style: {
      fill: "none"
    },
    d: "M0 0h56v56H0z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon awesome-arrow-circle-left",
    d: "M24.563 48.563a24 24 0 1 1 24-24 24 24 0 0 1-24 24zm2.8-13.9-7.306-7.006h17.667a2.317 2.317 0 0 0 2.323-2.323v-1.546a2.317 2.317 0 0 0-2.323-2.323H20.053l7.306-7.006a2.325 2.325 0 0 0 .041-3.319l-1.065-1.055a2.313 2.313 0 0 0-3.281 0L10.211 22.917a2.313 2.313 0 0 0 0 3.281L23.053 39.04a2.313 2.313 0 0 0 3.281 0l1.066-1.055a2.325 2.325 0 0 0-.041-3.319z",
    transform: "translate(3.437 3.438)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationArrowLeftThick);
export default __webpack_public_path__ + "static/media/navigation-arrow-left-thick.22fa5b0a9523782f6e4f30e7e33df313.svg";
export { ForwardRef as ReactComponent };